import React, { useEffect, useMemo } from 'react';
import { FormikProvider, useFormik } from 'formik';
import PropTypes from 'prop-types';

import { ButtonsPanel } from '../ButtonsPanel/ButtonsPanel';
import { StepFourFormFields } from './StepFourFormFields';
import { stepperInfo } from '../stepperInfo';
import { VEHICLE_TYPES } from '../../../../constants/constants';

import styles from './index.module.css';
import TrackSectionStickiness from '../../../analytics/TrackSectionStickiness ';

export const StepFour = ({
  step,
  draft,
  handleSaveAndClose,
  handleSubmit,
  handlePreviousStep,
  costCenterField,
  showAdditionalSourceField,
  showDocumentReasonForRideField,
  setFormikValues,
  disabledValues,
  showSubInformation = true,
  quickSchedule = false,
  setStepValid
}) => {
  const stepFourInitialValues = useMemo(() => {
    const base = {
      ...stepperInfo[3].values,
      ...(draft?.step4 || {}),
    };
    if (draft?.step2?.vehicleType === VEHICLE_TYPES.UBER_AMBULATORY_RIDE) {
      const mergedNotes =
        (base.rideNotes && String(base.rideNotes).trim() !== ''
          ? base.rideNotes
          : null) || draft?.step3?.rideNotes || '';
      return { ...base, rideNotes: mergedNotes };
    }
    return base;
  }, [draft]);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: stepFourInitialValues,
    validationSchema: stepperInfo[3].schema({
      costCenterField,
      showAdditionalSourceField,
      showDocumentReasonForRideField,
    }),
    onSubmit: handleSubmit,
  });

  const { values, isValid, setValues, validateForm } = formik;

  const isUberRide = draft?.step2?.vehicleType === VEHICLE_TYPES.UBER_AMBULATORY_RIDE;

  const isRequiredField = costCenterField?.isRequired || showAdditionalSourceField?.isRequired || showDocumentReasonForRideField?.isRequired;

  useEffect(() => {
    if (!draft?.step4) {
      return;
    }
    const merged = {
      ...stepperInfo[3].values,
      ...draft.step4,
      documentReasonForRide: Array.isArray(draft.step4.documentReasonForRide)
        ? draft.step4.documentReasonForRide
        : draft.step4.documentReasonForRide != null &&
            draft.step4.documentReasonForRide !== ""
          ? [draft.step4.documentReasonForRide]
          : [],
    };
    void setValues(merged, false);
    void validateForm();
  }, [draft?.id, draft?.step4, setValues, validateForm]);

  useEffect(() => {
    if (setStepValid) {
      const noOrgStepFourFields =
        !costCenterField?.show &&
        !showAdditionalSourceField?.show &&
        !showDocumentReasonForRideField?.show;
      if (noOrgStepFourFields && !isUberRide) {
        setStepValid(true);
      } else {
        setStepValid(formik.isValid);
      }
    }
  }, [
    formik.isValid,
    setStepValid,
    costCenterField?.show,
    showAdditionalSourceField?.show,
    showDocumentReasonForRideField?.show,
    isUberRide,
  ]);
  useEffect(() => {
    setFormikValues && setFormikValues(values, isValid, 'step4');
    return;
  }, [values, isValid, setFormikValues]);
  return (
    <>
      <TrackSectionStickiness sectionName="Create Ride Step 4" />
      {showSubInformation && !quickSchedule && <h2 className={styles.headTitle}>Step 4: Additional Information</h2>}

      {showSubInformation && !quickSchedule && !isRequiredField && !isUberRide && (
        <h3 className={styles.additionalTitle}>Additional Information</h3>
      )}


      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <StepFourFormFields
            {...formik}
            costCenterField={costCenterField}
            showAdditionalSourceField={showAdditionalSourceField}
            showDocumentReasonForRideField={showDocumentReasonForRideField}
            disabledValues={disabledValues}
            draft={draft}
            vehicleType={draft?.step2?.vehicleType}
          />
          {showSubInformation && (
            <ButtonsPanel
              disabled={!formik.isValid}
              step={step}
              handlePreviousStep={handlePreviousStep}
              handleSaveAndClose={handleSaveAndClose}
              handleSubmit={handleSubmit}
            />
          )}
        </form>
      </FormikProvider>

    </>
  );
};

StepFour.propTypes = {
  step: PropTypes.number,
  draft: PropTypes.object,
  handleSaveAndClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handlePreviousStep: PropTypes.func,
};
